import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `edit_time_series` anchor component.
 * Keep in sync with EditTimeSeriesProps in src/ui/uiConfig/anchorComponents/EditTimeSeries/EditTimeSeries.types.ts
 */
export const editTimeSeriesPropDocs: ComponentDocMap = {
  items: {
    description: 'Editable time-series definitions.',
    type: 'EditTimeSeriesItem[]',
    example: '[{ title: "__Price", data_id: "day_ahead_price", min_horizon_hour_offset: -24 }]',
  },
  'items[].sub_title': {
    description: 'Optional subtitle under title.',
    type: 'string | null',
  },
  'items[].min_horizon_hour_offset': {
    description: 'Minimum hour offset allowed for editing.',
    type: 'number',
    example: '-24',
  },
}
